module.exports = __webpack_public_path__ + "static/img/HT.1d4410d1.svg";